import { render } from "./speakers.vue?vue&type=template&id=2e7ebe54&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=2e7ebe54&lang=scss&scoped=true"
import "./speakers.vue?vue&type=style&index=1&id=2e7ebe54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e7ebe54"

export default script